import React, { useState, useEffect, useContext } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import lbl from "../../data/Labels.json";
import db from "../../services/query";

import HeadLegendItem from "./HeadLegendItem";
import StatsChartItem from "./StatsChartItem";
import MainTitle from "../common/MainTitle";

import { YearContext } from "../../contexts/yearContext";

const stats = [
  {
    id: "1",
    label: "محصلین",
    route: "dashboard/stats/students",
  },
  {
    id: "2",
    label: "استادان",
    route: "dashboard/stats/teachers",
  },
  {
    id: "3",
    label: "کارمندان",
    route: "dashboard/stats/staff",
    noDropDown: true
  },
  {
    id: "4",
    label: "صنف ها",
    route: "dashboard/stats/classes",
  },
];

const Stats = () => {
  const [legends, getLegends] = useState(null);
  const [_stats, updateStats] = useState(stats);
  const [faculties, updateFaculties] = useState([]);
  const { entryYear } = useContext(YearContext);

  useEffect(() => {
    const ac = new AbortController();

    db.getAll(`dashboard/stats/summary?entryYearId=${entryYear}`).then(
      ({ data: { data } }) => {
        getLegends(data[0]);
      }
    );

    db.getAll(`dropdowns/faculties`)
        .then(({ data: { data } }) => updateFaculties(data));

    return () => ac.abort();
  }, [entryYear]);

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(_stats);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    updateStats(items);
  };

  return (
    <div className="main-content">
      <div className="main-content-header">
        <div className="right-content select-off">
          <MainTitle title={lbl.Dashboard} />
        </div>
      </div>
      <div className="main-content-body transparent">
        <div className="head-legends-area">
          <HeadLegendItem
            count={legends?.class_count}
            title={"صنف ها"}
            icon={"class"}
          />

          <HeadLegendItem
            title={"کارمندان"}
            count={legends?.staff_count}
            icon={"employee"}
          />
          <HeadLegendItem
            title={"استادان"}
            count={legends?.teacher_count}
            icon={"teacher"}
          />
          <HeadLegendItem
            title={"محصلین"}
            count={legends?.student_count}
            icon={"student"}
          />
        </div>
        <DragDropContext onDragEnd={handleOnDragEnd}>
          <Droppable droppableId="stats">
            {(provided) => (
              <div
                className="chart-list-area"
                ref={provided.innerRef}
                {...provided.droppableProps}
              >
                {_stats.map(({ id, label, route , noDropDown }, index) => {
                  return (
                    <Draggable key={id} draggableId={id} index={index}>
                      {(provided) => (
                        <StatsChartItem headTitle={label} drpData={!noDropDown && faculties} route={route} {...provided} />
                      )}
                    </Draggable>
                  );
                })}

                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    </div>
  );
};

export default Stats;
